import { render, staticRenderFns } from "./MovieSoundtrackTab.vue?vue&type=template&id=abae36a0&scoped=true&"
import script from "./MovieSoundtrackTab.vue?vue&type=script&lang=js&"
export * from "./MovieSoundtrackTab.vue?vue&type=script&lang=js&"
import style0 from "./MovieSoundtrackTab.vue?vue&type=style&index=0&id=abae36a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abae36a0",
  null
  
)

export default component.exports